import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import { isMobile, isTablet } from 'react-device-detect'
import { Modal } from 'react-responsive-modal'
import { useLocation } from 'react-router-dom';

import Navigation from '../Challenges/components/Navigation/Navigation'
import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../GenericComponents/GenericMainCard'
import GenericSwitch from '../../GenericComponents/GenericSwitch'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericIcon from '../../GenericComponents/GenericIcon'
import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'
import ManageSub from './views/SingleSetting/ManageSub'

import CalculatorIcon from '../../assets/REDESIGN_Assets/UserProfile/calculator-icon.png'
import ChatIcon from '../../assets/REDESIGN_Assets/UserProfile/chat-icon.png'
import LiveIcon from '../../assets/REDESIGN_Assets/UserProfile/live-icon.png'
import SettingsIcon from '../../assets/REDESIGN_Assets/UserProfile/settings-icon.png'
import WaterIcon from '../../assets/REDESIGN_Assets/UserProfile/water-icon.png'
import LiveAltIcon from '../../assets/REDESIGN_Assets/UserProfile/Live.svg'
import SubManageIcon from '../../assets/REDESIGN_Assets/UserProfile/Settings/sub-manage-icon.svg'

import Settings from './views/Settings'

import {
  editUserTrainingDays,
  getTrainingDays,
  getUserData,
  setUserTrainingDays,
} from '../../Api/backendApi'
import AppContext from '../../context/appContext'

import history from '../../history'
import changeLocation from '../../utils/changeLocalization'

interface UserProfileInterface {
  setUserName: Function
}

const UserProfile: FC<UserProfileInterface> = ({ }) => {
  const appContext = useContext(AppContext)
  const location = useLocation()
  const [user, setUser] = useState(Object)
  const [isSettingsMode, setSettingsMode] = useState(false)
  const [modalMode, setModalMode] = useState('')
  const [isModalOpen, setModalOpen] = useState(false)
  const [isChallengeMode, setChallengeMode] = useState(false)

  useEffect(() => {
    obtainUser()
  }, [])

  useEffect(() => {

    if (location.state && location.state.challengeMode) {

      setChallengeMode(true)
    }
  }, [location])

  const goBackToMainpage = () => {
    history.push('/trening')
  }
  const goToChallengeMainpage = () => {
    history.push('/wyzwania')
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await getUserData()
    setUser(user)
    appContext.updateAppState('user', user)
  }

  const openSpecificModal = (mode: string) => {
    switch (mode) {
      case 'manageSub':
        setModalMode(mode)
        setModalOpen(true)
        break

      default:
        break
    }
  }

  const modalStyles = {
    closeButton: {
      display: 'none',
    },
    modal: {
      maxWidth: 'unset',
      width: isMobile ? '95vw' : '55vw',
      overflow: 'unset',
      left: '0',
      boxsizing: 'border-box',
      margin: isMobile ? 'auto' : 'unset',
      borderRadius: '30px',
    },
  }

  return !isSettingsMode ? (
    <>
      <GenericBackgroundLayer
        fDir={'column'}
        justify={'flex-start'}
        align={'center'}
        className={`${appContext.appState.theme == 'light' ? 'light' : 'standard'
          } user-profile`}
      >
        {!isChallengeMode ? <NavigationBar
          isPlayerView={false}
          backButtonAction={isChallengeMode ? goToChallengeMainpage : goBackToMainpage}
        /> : <Navigation />}
        {(isMobile) && (
          <GenericMobileTopNavigation
            isPlayerView={false}
            dietCartClick={null}
            handleClick={isChallengeMode ? () => goToChallengeMainpage() : () => goBackToMainpage()}
          />
        )}
        <GenericMainCard
          flexDir={'column'}
          className="standard"
          width={isMobile ? '95%' : '60%'}
          margin={isMobile ? '0 auto' : '5% auto 0 auto'}
        >
          <GenericTextSpan
            fSize={isMobile ? '2rem' : '1.8rem'}
            margin={'0 0 2% 0'}
          >
            Twój profil
          </GenericTextSpan>
          <GenericTextSpan
            margin={isMobile && !isTablet ? '6% 0 0 5%' : isTablet ? '2% 0 0 5%' : '3% 0 0 0'}
            fSize={'1.9rem'}
            tAlign={isMobile ? 'left' : 'unset'}
            width={isMobile ? '100%' : 'unset'}
          >
            Cześć {user && user.name}!
          </GenericTextSpan>
          <GenericTextSpan
            tAlign={isMobile ? 'left' : 'unset'}
            width={isMobile ? '100%' : 'unset'}
            margin={isMobile ? '1% 0 4% 5%' : '1% 0 3% 0'}
            fSize={'1rem'}
            opacity={'0.5'}
          >
            Super, że jesteś
          </GenericTextSpan>
          <GenericButton
            padding={'20px'}
            fSize={'0.9rem'}
            margin={isMobile && !isTablet ? '3% 0 ' : '1% 0'}
            width={isMobile ? '95%' : '50%'}
            className={'gradient with-green-arrow'}
            onClick={() => openSpecificModal('manageSub')}
          >
            <GenericIcon
              margin={'0 10px 0 0'}
              width={'1.3rem'}
              height={'1.3rem'}
              src={SubManageIcon}
            />
            Moja subskrypcja
          </GenericButton>
          <GenericButton
            onClick={() => changeLocation({ pathname: '/kalkulator', challengeMode: isChallengeMode })}
            fSize={'0.9rem'}
            padding={'20px'}
            margin={isMobile && !isTablet ? '3% 0 ' : '1% 0'}
            width={isMobile ? '95%' : '50%'}
            className={'gradient with-green-arrow'}
          >
            <GenericIcon
              width={'1.3rem'}
              height={'1.3rem'}
              margin={'0 10px 0 0'}
              src={CalculatorIcon}
            />
            Kalkulator BMR
          </GenericButton>
          {/* <GenericButton
            fSize={'0.9rem'}
            padding={'20px'}
            margin={isMobile ? '3% 0 ' : '1% 0'}
            width={isMobile ? '95%' : '50%'}
            className={'gradient with-green-arrow'}
            onClick={() => changeLocation('/picie-wody')}
          >
            <GenericIcon
              width={'1.3rem'}
              margin={'0 10px 0 0'}
              height={'1.3rem'}
              src={WaterIcon}
            />
            Plan picia wody
          </GenericButton> */}
          <GenericButton
            padding={'20px'}
            fSize={'0.9rem'}
            margin={isMobile && !isTablet ? '3% 0 ' : '1% 0'}
            width={isMobile ? '95%' : '50%'}
            className={'gradient with-green-arrow'}
            onClick={
              user && user.has_subscription
                ? () => changeLocation('/chatbox')
                : null
            }
          >
            <GenericIcon
              margin={'0 10px 0 0'}
              width={'1.3rem'}
              height={'1.3rem'}
              src={ChatIcon}
            />
            ChatBox
          </GenericButton>
          <GenericButton
            padding={'20px'}
            fSize={'0.9rem'}
            margin={isMobile && !isTablet ? '3% 0 ' : '1% 0'}
            width={isMobile ? '95%' : '50%'}
            className={'gradient with-green-arrow'}
            onClick={() => changeLocation({ pathname: '/live', state: { challengeMode: true } })}
          >
            <GenericIcon
              margin={'0 10px 0 0'}
              src={LiveAltIcon}
              width={'1.3rem'}
              height={'1.3rem'}
            />
            Live
          </GenericButton>
          <GenericButton
            onClick={() => setSettingsMode(true)}
            padding={'20px'}
            fSize={'0.9rem'}
            margin={isMobile && !isTablet ? '3% 0 ' : '1% 0'}
            width={isMobile ? '95%' : '50%'}
            className={'gradient with-green-arrow'}
          >
            <GenericIcon
              margin={'0 10px 0 0'}
              width={'1.3rem'}
              height={'1.3rem'}
              src={SettingsIcon}
            />
            Ustawienia
          </GenericButton>{' '}
        </GenericMainCard>
        <Modal
          open={isModalOpen}
          animationDuration={700}
          onClose={() => setModalOpen(false)}
          center
          styles={modalStyles}
        >
          {modalMode == 'manageSub' && (
            <ManageSub isChallengeMode={isChallengeMode} closeModal={() => setModalOpen(false)} />
          )}
        </Modal>
      </GenericBackgroundLayer>
    </>
  ) : (
    <Settings isChallengeMode={isChallengeMode} setSettingsMode={setSettingsMode} user={user} />
  )
}

export default UserProfile
